// navStructure.js
import gear from "../../Assets/Icons/Gear-icon.png";
import review from "../../Assets/Icons/reviews-icon.png";
import order from "../../Assets/Icons/order-history-icon.png";
import heart from "../../Assets/Icons/Heart-icon.png";

export const PCPNavStructure = [
  {
    id: "info",
    name: "Info & Settings",
    icon: gear,
    sidebar: [
      { id: "profile", name: "Profile", component: "ProfileComponent" },
      { id: "addresses", name: "Addresses", component: "AddressesComponent" },
      {
        id: "change-password",
        name: "Change Password",
        component: "ChangePasswordComponent",
      },
    ],
  },
  {
    id: "orders",
    name: "Order History",
    icon: order,
    sidebar: [
      {
        id: "unpaid",
        name: "Unpaid",
        component: "UnpaidComponent",
      },
      {
        id: "pendingapproval",
        name: "Pending Approval",
        component: "PendingApprovalComponent",
      },
      {
        id: "partiallypaid",
        name: "Partially Paid",
        component: "PartiallyPaidComponent",
      },
      {
        id: "paid",
        name: "Fully Paid",
        component: "PaidComponent",
      },
      {
        id: "toReceive",
        name: "To Receive",
        component: "ToReceiveOrdersComponent",
      },
      {
        id: "completed",
        name: "Completed",
        component: "CompleteOrderComponent",
      },
      {
        id: "cancelled",
        name: "Cancelled",
        component: "CancelledOrdersComponent",
      },
      {
        id: "declined",
        name: "Declined",
        component: "DeclinedComponent",
      },
      {
        id: "refunded",
        name: "Refunded",
        component: "RefundedOrderComponent",
      },
    ],
  },
  {
    id: "wishlist",
    name: "Wishlist",
    icon: heart,
    sidebar: [
      {
        id: "wishlist",
        name: "Wishlist",
        component: "Wishlist",
      },
    ],
  },
];
